export const usePageEnvironment = () => {
  const { environment } = useRuntimeConfig().public
  const { path } = useRoute()
  // useRequestURL contains __nuxt_error as path in SSR on 404, not the requested url and useRoute has no hostname
  const host = useRequestURL().hostname

  return { environment, host, path }
}
